/**
 * Dev-only preview helpers for npm run dev:page (scripts/dev-pages.ts).
 * Strip in production — see docs/build/DEV_PREVIEW_STRIP.md
 */

// @mcc-dev-preview:start dev-preview-core
export const DEV_CARD_ID = 'dev-preview';

export function isDevPreviewEnabled(): boolean {
  return process.env.NODE_ENV === 'development';
}

export function parseDevState<T extends string>(
  searchParams: URLSearchParams,
  allowed: readonly T[]
): T | null {
  if (!isDevPreviewEnabled()) return null;
  const raw = searchParams.get('devState');
  if (raw && allowed.includes(raw as T)) {
    return raw as T;
  }
  return null;
}

/** Resolve devState from query param or legacy alias flags. */
export function resolveDevState<T extends string>(
  searchParams: URLSearchParams,
  allowed: readonly T[],
  aliases: Array<{ when: (p: URLSearchParams) => boolean; state: T }>
): T | null {
  const direct = parseDevState(searchParams, allowed);
  if (direct) return direct;
  if (!isDevPreviewEnabled()) return null;
  for (const { when, state } of aliases) {
    if (when(searchParams)) return state;
  }
  return null;
}
// @mcc-dev-preview:end dev-preview-core
